var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("q-toggle", {
              attrs: { label: _vm.$t("label.shared") },
              on: { input: _vm.update },
              model: {
                value: _vm.settings.shared,
                callback: function($$v) {
                  _vm.$set(_vm.settings, "shared", $$v)
                },
                expression: "settings.shared"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm.updating
              ? _c("q-spinner-cube", {
                  attrs: { color: "primary", size: "2em" }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.settings.shared
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("q-input", {
                attrs: {
                  value: _vm.dateInputValue,
                  label: _vm.$t("label.sharedUntil"),
                  filled: "",
                  dense: ""
                },
                on: {
                  click: function() {
                    return _vm.$refs.qDateProxy.show()
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append",
                      fn: function() {
                        return [
                          _c(
                            "q-icon",
                            {
                              staticClass: "cursor-pointer",
                              attrs: { name: "event" }
                            },
                            [
                              _c(
                                "q-popup-proxy",
                                {
                                  ref: "qDateProxy",
                                  attrs: {
                                    "transition-show": "scale",
                                    "transition-hide": "scale"
                                  }
                                },
                                [
                                  _c("q-date", {
                                    attrs: {
                                      value: _vm.datePickerValue,
                                      options: _vm.sharedUntilDates,
                                      minimal: ""
                                    },
                                    on: { input: _vm.datePickerInput }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2260238162
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("q-toggle", {
            attrs: { label: _vm.$t("label.simplified") },
            on: { input: _vm.update },
            model: {
              value: _vm.settings.simplified,
              callback: function($$v) {
                _vm.$set(_vm.settings, "simplified", $$v)
              },
              expression: "settings.simplified"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("q-toggle", {
            attrs: { label: _vm.$t("label.showBundleImages") },
            on: { input: _vm.update },
            model: {
              value: _vm.settings.showBundleImages,
              callback: function($$v) {
                _vm.$set(_vm.settings, "showBundleImages", $$v)
              },
              expression: "settings.showBundleImages"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("q-separator", { attrs: { spaced: "" } }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("q-btn", {
              attrs: {
                label: _vm.$t("button.copyWatchlistLink"),
                color: "primary",
                disable: _vm.updating || !_vm.settings.shared
              },
              on: {
                click: function($event) {
                  return _vm.updateClipboard(_vm.permalink)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("q-btn", {
              attrs: {
                label: _vm.$t("button.copyNeutralWatchlistLink"),
                color: "secondary",
                disable: _vm.updating || !_vm.settings.shared
              },
              on: {
                click: function($event) {
                  return _vm.updateClipboard(_vm.neutralPermalink)
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }